import React, { useCallback, useState } from 'react';
import { debounce } from '@material-ui/core';
import { FormApi } from 'final-form';
import api from 'api/api';
import { IApiResponse } from 'utils/models';
import Input from 'ui/Input';
import { onlyNCharacters, onlyNumbers } from 'utils/formatters';
import InputHint from '../InputHint/InputHint';
import { IFormValues, IApiPrepaidCardBen } from '../Beneficiaries.model';

type FormType = FormApi<IFormValues, Partial<IFormValues>>;

interface IAddBeneficiaryPrepaidCard {
  form: FormType;
  submitting: boolean;
  setValidatedAccountNo: (boolean) => void;
}

const AddBeneficiaryPrepaidCard = ({ form, submitting, setValidatedAccountNo }: IAddBeneficiaryPrepaidCard) => {
  const [nameHint, setNameHint] = useState('');
  const [isLookingUp, setLookingUp] = useState(false);

  const clearNameHint = () => setNameHint('');

  const lookupAccount = (customerId: string) => {
    api
      .get(`/transfer/validatePrepaidCard?customerId=${String(customerId)}`, {}, true, true)
      .then((response: IApiPrepaidCardBen) => {
        setLookingUp(false);
        setValidatedAccountNo(true);
        setNameHint('');
        form.mutators.changeFieldValue('cardName', response.customerResponse.preferredNameField);
        form.mutators.changeFieldValue('phoneNumber', response.customerResponse.mobilePhoneNumberField);
      })
      .catch((error: IApiResponse) => {
        console.error(error);
        setLookingUp(false);
        setValidatedAccountNo(true);
        setNameHint(error.description);
        form.mutators.changeFieldValue('cardName', '');
        form.mutators.changeFieldValue('phoneNumber', '');
      });
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debounced = useCallback(debounce(lookupAccount, 500), []);

  const handleChangeCustomerId = ({ target }) => {
    setLookingUp(true);
    setValidatedAccountNo(false);
    debounced(target.value as string);
  };
  return (
    <>
      <Input name="name" label="Full Name" disabled={submitting} />
      <Input
        name="cardCustomerId"
        label="Customer ID"
        disabled={submitting}
        onInput={handleChangeCustomerId}
        fieldProps={{
          parse: (value: string) => onlyNCharacters(10)(onlyNumbers(value)),
        }}
      />
      {(nameHint || isLookingUp) && <InputHint hint={nameHint} loading={isLookingUp} onClose={clearNameHint} />}
      <Input name="cardName" label="Card Name" disabled />
      <Input name="phoneNumber" label="Phone Number" disabled />
      <Input
        name="last4digit"
        label="Card’s last 4 digits"
        disabled={submitting}
        fieldProps={{
          parse: (value: string) => onlyNCharacters(4)(onlyNumbers(value)),
        }}
      />
    </>
  );
};

export default AddBeneficiaryPrepaidCard;
